import { lazy, type ComponentType } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const OportunidadesAtivas = lazy(() => import('@/features/comercial/components/OportunidadesAtivas'));
const OportunidadesEncerradas = lazy(
  () => import('@/features/comercial/components/OportunidadesEncerradas'),
);
const PropostaDetails = lazy(() => import('@/features/proposta/components/PropostaDetails'));
const PropostaImagem = lazy(() => import('@/features/proposta/components/PropostaImagem'));
const PropostaParametro = lazy(() => import('@/features/proposta/components/PropostaParametro'));
const OportunidadeStatus = lazy(
  () => import('@/features/comercial/components/config/OportunidadeStatus'),
);

function makeOnBackOnly(Component: ComponentType<{ onBack: () => void }>) {
  return function V() {
    const { actions } = useNavigation();
    return <Component onBack={actions.goBack} />;
  };
}

function OportunidadesAtivasView() {
  const { actions } = useNavigation();
  return <OportunidadesAtivas onBack={actions.goBack} />;
}

function OportunidadesEncerradasView() {
  const { actions } = useNavigation();
  return <OportunidadesEncerradas onBack={actions.goBack} />;
}

function PropostaDetailsView() {
  const { selection, actions } = useNavigation();
  return (
    <PropostaDetails
      itemId={selection.propostaId ?? ''}
      onBack={actions.goBack}
      onDelete={actions.goBack}
      onOportunidadeClick={(oportunidadeId: string) => {
        actions.setDrawerOportunidadeId(oportunidadeId);
        actions.navigate('oportunidades-ativas-v2');
      }}
    />
  );
}

export const comercialViews: Partial<ViewRegistry> = {
  'oportunidades-ativas-v2': { component: OportunidadesAtivasView, guard: {} },
  'oportunidades-encerradas-v2': {
    component: OportunidadesEncerradasView,
    guard: { screen: 'oportunidades-encerradas-v2' },
  },
  'proposta-details': {
    component: PropostaDetailsView,
    guard: { screen: 'proposta-details' },
  },
  'proposta-grupo-imagem-manager': {
    component: makeOnBackOnly(PropostaImagem),
    guard: { screen: 'proposta-grupo-imagem-manager' },
  },
  'proposta-parametro': {
    component: makeOnBackOnly(PropostaParametro),
    guard: { screen: 'proposta-parametro' },
  },
  'oportunidade-status': {
    component: makeOnBackOnly(OportunidadeStatus),
    guard: { screen: 'oportunidade-status' },
  },
};
